import N8nPromptInput from './N8nPromptInput.vue';

export default N8nPromptInput;
